import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
export default function memoize(callback) {
    var previous;
    var result;
    return function() {
        for(var _len = arguments.length, dependencies = new Array(_len), _key = 0; _key < _len; _key++){
            dependencies[_key] = arguments[_key];
        }
        var hasChanged = false;
        if (previous) {
            if (previous.length !== dependencies.length) {
                hasChanged = true;
            } else {
                for(var i = 0; i < previous.length; i++){
                    if (previous[i] !== dependencies[i]) {
                        hasChanged = true;
                        break;
                    }
                }
            }
        } else {
            hasChanged = true;
        }
        previous = dependencies;
        if (hasChanged || result === undefined) {
            result = callback.apply(void 0, _to_consumable_array(dependencies));
        }
        return result;
    };
}
